import { Link } from 'react-router-dom';
import { achievements } from '@/mocks/home';
import { fetchAchievementList } from '@/services/achievement';
import { adaptAchievements } from '@/services/adapters';
import { useRequest } from '@/hooks/useRequest';
import SectionHeading from '@/components/base/SectionHeading';

const HOME_LIMIT = 4;

export default function AchievementsSection() {
  // 接口失败时降级为 mock 数据
  const { data: achievementList } = useRequest(
    () => fetchAchievementList({ pageIndex: 1, pageSize: HOME_LIMIT }).then((res) => adaptAchievements(res.list)),
    { fallback: achievements.slice(0, HOME_LIMIT) },
  );

  // 无数据时整段隐藏，避免出现只有标题与按钮的空板块
  if (achievementList.length === 0) return null;

  return (
    <section id="achievements" className="scroll-mt-24 w-full px-4 md:px-8 py-14 md:py-20 bg-secondary-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="成果转化"
          title="让科研成果，走向临床应用"
          description="记录平台在数智中医、中西医结合与经验传承方向的成果转化进展，推动科研创新真正服务临床与产业。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {achievementList.map((item) => (
            <Link
              key={item.id}
              to={`/achievements/${item.id}`}
              className="group flex flex-col sm:flex-row rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full sm:w-2/5 h-44 sm:h-auto overflow-hidden shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 成果转化`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500 mb-2">
                  <i className="ri-calendar-line"></i>
                  {item.date}
                </span>
                <h3 className="font-heading font-semibold text-base text-foreground-900 leading-snug text-balance line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
                <span className="mt-auto pt-3 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                  查看详情
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/achievements"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部成果转化
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}